import { getOrCreateSessionId } from './sessionStorage';
import { getUtmDataFromLocalStorage } from '../orderPage/orderCompletion/utmLocalStorage';

const getQueryParams = () => {
  return new URLSearchParams(window.location.search);
};

const getAllClickIds = () => {
  const params = getQueryParams();
  return {
    gclid: params.get('gclid') || '',
    dclid: params.get('dclid') || '',
    gbraid: params.get('gbraid') || '',
    wbraid: params.get('wbraid') || '',
    fbclid: params.get('fbclid') || '',
    ttclid: params.get('ttclid') || '',
    msclkid: params.get('msclkid') || '',
    epik: params.get('epik') || '',
    scid: params.get('scid') || '',
  };
};

const getBrowserInfo = () => {
  const deviceType = (() => {
    const ua = navigator.userAgent;
    if (/tablet|ipad|playbook|silk/i.test(ua)) return 'tablet';
    if (/mobile|iphone|ipod|android|blackberry|opera|mini|windows\sce|palm|smartphone|iemobile/i.test(ua))
      return 'mobile';
    return 'desktop';
  })();

  return {
    user_agent: navigator.userAgent,
    language: navigator.language || '',
    screen_resolution: `${window.screen.width}x${window.screen.height}`,
    device_type: deviceType,
  };
};

const getGAClientId = () => {
  const gaCookie = document.cookie.split('; ').find((row) => row.startsWith('_ga='));

  if (gaCookie) {
    const parts = gaCookie.split('=')[1].split('.');
    if (parts.length >= 4) {
      return `${parts[2]}.${parts[3]}`;
    }
  }
  return '';
};

const getGA4SessionId = () => {
  const ga4Cookie = document.cookie.split('; ').find((row) => row.startsWith('_ga_'));

  if (ga4Cookie) {
    const cookieValue = ga4Cookie.split('=')[1];
    // Parse the session ID from the format: GS2.1.s1754232131$o1$g0$t1754232338$j44$l0$h0
    const sessionMatch = cookieValue.match(/s(\d+)/);
    if (sessionMatch) {
      return sessionMatch[1];
    }
  }
  return '';
};

const getFacebookCookies = () => {
  const fbcCookie = document.cookie.split('; ').find((row) => row.startsWith('_fbc='));

  const fbpCookie = document.cookie.split('; ').find((row) => row.startsWith('_fbp='));

  let fbc = fbcCookie ? fbcCookie.split('=')[1] : '';
  const fbp = fbpCookie ? fbpCookie.split('=')[1] : '';

  if (!fbc && getQueryParams().get('fbclid')) {
    const fbclid = getQueryParams().get('fbclid');
    const timestamp = Math.floor(Date.now() / 1000);
    fbc = `fb.1.${timestamp}.${fbclid}`;
  }

  return { fbc, fbp };
};

const getTikTokCookies = () => {
  const ttpCookie = document.cookie.split('; ').find((row) => row.startsWith('_ttp='));

  let ttp = ttpCookie ? ttpCookie.split('=')[1] : '';

  // If no _ttp cookie found, try to get from URL parameter or use ttclid
  if (!ttp) {
    const urlTtp = getQueryParams().get('ttp');
    const ttclid = getQueryParams().get('ttclid');
    ttp = urlTtp || ttclid || '';
  }

  return ttp;
};

export const createMonkeybookSession = () => {
  const now = Date.now();
  const sessionId = getOrCreateSessionId();

  const clickIds = getAllClickIds();
  const browserInfo = getBrowserInfo();
  const fbCookies = getFacebookCookies();
  const ttp = getTikTokCookies();
  const utmParams = getUtmDataFromLocalStorage();

  const monkeybookSession = {
    gclid: clickIds.gclid,
    dclid: clickIds.dclid,
    gbraid: clickIds.gbraid,
    wbraid: clickIds.wbraid,
    fbclid: clickIds.fbclid,
    ttclid: clickIds.ttclid,
    msclkid: clickIds.msclkid,
    epik: clickIds.epik,
    scid: clickIds.scid,
    ttp,
    fbc: fbCookies.fbc,
    fbp: fbCookies.fbp,

    user_agent: browserInfo.user_agent,
    language: browserInfo.language,
    screen_resolution: browserInfo.screen_resolution,
    device_type: browserInfo.device_type,

    client_id: getGAClientId(),
    ga4_session_id: getGA4SessionId(),
    user_id: '',
    session_id: sessionId,

    document_referrer: document.referrer,
    page_url: window.location.href,
    landing_page: window.location.href,

    first_touch_time: now,
    page_load_time: now,

    ...utmParams,
  };

  return monkeybookSession;
};
